module.exports = __webpack_public_path__ + "img/chilly1.7cfed03d.png";